import { useEffect, useState } from "react";
import { GasOrder } from "../../types/gasOrder.types";
import { getPaidGasOrdersByStation } from "../../services/gasOrdersService";
import { useUserStationParam } from "../../hooks/useUserStationParam";
import {
  PageContainer,
  PageHeader,
  PageTitle,
} from "../../components/PageLayout";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { toast } from "react-toastify";
import { formatIsoToBrDateTimeShort } from "../../utils/functions";

export default function GasOrdersPage() {
  const { stationId: selectedStationId, resolving: resolvingStation } = useUserStationParam();
  const [orders, setOrders] = useState<GasOrder[]>([]);
  const [loading, setLoading] = useState(false);

  async function loadOrders(silent = false) {
    if (!selectedStationId) return;
    if (!silent) setLoading(true);
    try {
      const data = await getPaidGasOrdersByStation(selectedStationId);
      setOrders(data);
    } catch {
      if (!silent) toast.error("Erro ao carregar abastecimentos.");
      setOrders((prev) => (silent ? prev : []));
    } finally {
      if (!silent) setLoading(false);
    }
  }

  useEffect(() => {
    loadOrders();
    if (!selectedStationId) return;
    const intervalId = setInterval(() => loadOrders(true), 30 * 1000);
    return () => clearInterval(intervalId);
  }, [selectedStationId]);

  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>Abastecimentos</PageTitle>
      </PageHeader>

      {resolvingStation ? (
        <p>Carregando...</p>
      ) : !selectedStationId ? (
        <p>Nenhum posto vinculado ao usuário.</p>
      ) : loading ? (
        <p>Carregando...</p>
      ) : orders.length === 0 ? (
        <p>Nenhum abastecimento encontrado para este posto.</p>
      ) : (
        <TableContainer component={Paper} sx={{ overflowX: "auto", marginTop: "16px" }}>
          <Table sx={{ minWidth: 650 }} aria-label="gas orders table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ whiteSpace: "nowrap" }}>Bomba / Tipo</TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>Origem</TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>Cupom</TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>Data pagamento</TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="right">Quantidade</TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }} align="right">Valor</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders.map((order) => (
                <TableRow key={order.id} hover>
                  <TableCell sx={{ whiteSpace: "nowrap", fontWeight: "bold" }}>
                    Bomba {order.gasPump} · {order.type}
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>{order.source}</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>{order.couponCode || "—"}</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    {order.updatedAt
                      ? formatIsoToBrDateTimeShort(order.updatedAt)
                      : "—"}
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }} align="right">
                    {order.quantity.toFixed(2)} L
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }} align="right">
                    R$ {order.price.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </PageContainer>
  );
}
